import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import { changeColor } from "@/lib/tracking";

export const WeightHistory = ({ records, locale }) => {
  const { t } = useTranslation();
  return <div className="bg-card border border-border rounded-xl p-5">
    <h2 className="font-semibold mb-3">{t("progress.history")}</h2>
    {records.slice(0, 10).map((record, index) => {
      const diff = index < records.length - 1 ? record.weight - records[index + 1].weight : null;
      const Icon = diff < -0.1 ? TrendingDown : diff > 0.1 ? TrendingUp : Minus;
      return <div key={record.id} data-testid={`weight-record-${record.id}`} className="flex items-center justify-between gap-3 py-2 border-b border-border/50 last:border-0">
        <div className="min-w-0"><p className="font-semibold">{record.weight} kg</p><p className="text-xs text-muted-foreground break-words [overflow-wrap:anywhere]">{format(new Date(record.created_date), "dd/MM/yyyy", { locale })}{record.note && ` · ${record.note}`}</p></div>
        {diff !== null && <span className={`flex items-center gap-1 shrink-0 text-sm ${changeColor(diff)}`}><Icon className="w-5 h-5" />{diff > 0 ? "+" : ""}{diff.toFixed(1)}</span>}
      </div>;
    })}
  </div>;
};